import { createStructuredSelector } from "reselect";
import {
    EQP_ASSIGN_USER,
    EQP_ASSIGN_USER_SUCCESS,
    EQP_ASSIGN_USER_ERROR,
    EQP_ASSIGN_TECH_USER_LIST,
    EQP_ASSIGN_TECH_USER_LIST_SUCCESS,
    EQP_ASSIGN_TECH_USER_LIST_ERROR,
    EQP_ASSIGN_UNIT_HEALTH,
    EQP_ASSIGN_UNIT_HEALTH_SUCCESS,
    EQP_ASSIGN_UNIT_HEALTH_ERROR,
    EQP_ASSIGN_DELIVERY_ORDER,
    EQP_ASSIGN_DELIVERY_ORDER_SUCCESS,
    EQP_ASSIGN_DELIVERY_ORDER_ERROR,
    EQP_ASSIGN_EQUIPMENT,
    EQP_ASSIGN_EQUIPMENT_SUCCESS,
    EQP_ASSIGN_EQUIPMENT_ERROR,
    EQP_ASSIGN_DOCUMENT_TYPE,
    EQP_ASSIGN_DOCUMENT_TYPE_SUCCESS,
    EQP_ASSIGN_DOCUMENT_TYPE_ERROR,
    EQP_ASSIGN_USER_ASSIGN,
    EQP_ASSIGN_USER_ASSIGN_SUCCESS,
    EQP_ASSIGN_USER_ASSIGN_ERROR,
    EQP_ASSIGN_LIST,
    EQP_ASSIGN_LIST_SUCCESS,
    EQP_ASSIGN_LIST_ERROR,
    EQP_ASSIGN_LIST_SEARCH_CHANGE,
    EQP_ASSIGN_LIST_PAGE_SET,
    EQP_ASSIGN,
    EQP_ASSIGN_SUCCESS,
    EQP_ASSIGN_ERROR,
    EQP_ASSIGN_HISTORY,
    EQP_ASSIGN_HISTORY_SUCCESS,
    EQP_ASSIGN_HISTORY_ERROR

} from "../../actions";

export const NAME = 'assignTechnic';

export const EqpAssignUser = (data) => ({
    type: EQP_ASSIGN_USER,
    payload: data
});

export const EqpAssignUserSuccess = (data) => ({
    type: EQP_ASSIGN_USER_SUCCESS,
    payload: data
});

export const EqpAssignUserError = (error) => ({
    type: EQP_ASSIGN_USER_ERROR,
    payload: error
});

export const EqpAssignTechUserList = (data) => ({
    type: EQP_ASSIGN_TECH_USER_LIST,
    payload: data
});

export const EqpAssignTechUserListSuccess = (data) => ({
    type: EQP_ASSIGN_TECH_USER_LIST_SUCCESS,
    payload: data
});

export const EqpAssignTechUserListError = (error) => ({
    type: EQP_ASSIGN_TECH_USER_LIST_ERROR,
    payload: error
});

export const EqpAssignUnitHealth = (data) => ({
    type: EQP_ASSIGN_UNIT_HEALTH,
    payload: data
});

export const EqpAssignUnitHealthSuccess = (data) => ({
    type: EQP_ASSIGN_UNIT_HEALTH_SUCCESS,
    payload: data
});

export const EqpAssignUnitHealthError = (error) => ({
    type: EQP_ASSIGN_UNIT_HEALTH_ERROR,
    payload: error
});

export const EqpAssignDeliveryOrder = (data) => ({
    type: EQP_ASSIGN_DELIVERY_ORDER,
    payload: data
});

export const EqpAssignDeliveryOrderSuccess = (data) => ({
    type: EQP_ASSIGN_DELIVERY_ORDER_SUCCESS,
    payload: data
});

export const EqpAssignDeliveryOrderError = (error) => ({
    type: EQP_ASSIGN_DELIVERY_ORDER_ERROR,
    payload: error
});

export const EqpAssignEquipment = (data) => ({
    type: EQP_ASSIGN_EQUIPMENT,
    payload: data
});

export const EqpAssignEquipmentSuccess = (data) => ({
    type: EQP_ASSIGN_EQUIPMENT_SUCCESS,
    payload: data
});

export const EqpAssignEquipmentError = (error) => ({
    type: EQP_ASSIGN_EQUIPMENT_ERROR,
    payload: error
});

export const EqpAssignDocumentType = (data) => ({
    type: EQP_ASSIGN_DOCUMENT_TYPE,
    payload: data
});

export const EqpAssignDocumentTypeSuccess = (data) => ({
    type: EQP_ASSIGN_DOCUMENT_TYPE_SUCCESS,
    payload: data
});

export const EqpAssignDocumentTypeError = (error) => ({
    type: EQP_ASSIGN_DOCUMENT_TYPE_ERROR,
    payload: error
});

export const EqpAssignUserAssign = (data) => ({
    type: EQP_ASSIGN_USER_ASSIGN,
    payload: data
});

export const EqpAssignUserAssignSuccess = (data) => ({
    type: EQP_ASSIGN_USER_ASSIGN_SUCCESS,
    payload: data
});

export const EqpAssignUserAssignError = (error) => ({
    type: EQP_ASSIGN_USER_ASSIGN_ERROR,
    payload: error
});

export const EqpAssignList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: EQP_ASSIGN_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const EqpAssignListSuccess = (data) => ({
    type: EQP_ASSIGN_LIST_SUCCESS,
    payload: data
});

export const EqpAssignListError = (error) => ({
    type: EQP_ASSIGN_LIST_ERROR,
    payload: error
});

export const EqpAssignListSearchChange = (data) => ({
    type: EQP_ASSIGN_LIST_SEARCH_CHANGE,
    payload: data
});

export const EqpAssignListPageSet = (data) => ({
    type: EQP_ASSIGN_LIST_PAGE_SET,
    payload: data
});

export const EqpAssign = (page, num_page, orderBy, filters, data) => ({
    type: EQP_ASSIGN,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const EqpAssignSuccess = (message) => ({
    type: EQP_ASSIGN_SUCCESS,
    payload: message
});

export const EqpAssignError = (error) => ({
    type: EQP_ASSIGN_ERROR,
    payload: error
});

export const EqpAssignHistory = (data) => ({
    type: EQP_ASSIGN_HISTORY,
    payload: data
});

export const EqpAssignHistorySuccess = (data) => ({
    type: EQP_ASSIGN_HISTORY_SUCCESS,
    payload: data
});

export const EqpAssignHistoryError = (error) => ({
    type: EQP_ASSIGN_HISTORY_ERROR,
    payload: error
});

const assignTechnic = (state) => state[NAME];

export const AssignTechnicSelector = createStructuredSelector({
    assignTechnic
})
